import types from "./types";
const defaultValues = {
    age: [],
    race: [],
    gender: [],
    job: [],
    time: [],
    shift: [],
    worker: [],

    location: [],
    hr: [],
    company: [],
    cc: [],
    ccn: [],
    backup: [],

    veteran: [],
    ethnicity: [],

    employment: [],
    specialty: [],

    unit: [],
    position: [],

    loc: [],

    otherFilters: {},

    count: -1,
    summary: ''

};

export default function reducer(state = defaultValues, action) {
  switch (action.type) {
  case types.SET_FILTERS: {
    return {
      ...state,
      age: action.payload.age,
      race: action.payload.race,
      gender: action.payload.gender,
      job: action.payload.job,
      time: action.payload.time,
      shift: action.payload.shift,
      worker: action.payload.worker,
      count: action.payload.count,
      summary: action.payload.summary,

      location: action.payload.location,
      hr: action.payload.hr,
      company: action.payload.company, 
      cc: action.payload.cc,
      ccn: action.payload.ccn,
      backup: action.payload.backup,
      veteran: action.payload.veteran,
      ethnicity: action.payload.ethnicity,

      employment: action.payload.employment,
      specialty: action.payload.specialty,

      unit: action.payload.unit,
      position: action.payload.position,

      loc: action.payload.loc,

      otherFilters: action.payload.otherFilters
    };
  }
  case types.CLEAR_FILTERS: {
    return {
      ...state,
      age: [],
      race: [],
      gender: [],
      job: [],
      time: [],
      shift: [],
      worker: [],

      location: [],
      hr: [],
      company: [],
      cc: [],
      ccn: [],
      backup: [],

      veteran: [],
      ethnicity: [],

      employment: [],
      specialty: [],

      unit: [],
      position: [],

      loc: [],

      otherFilters: {},
      
      count: -1,
      summary: ''
    }
  }
  default: {
    return state;
  }
  }
}



// WEBPACK FOOTER //
// ./src/redux/filters/reducers.js